import { useEffect, useState } from "react";
// REDUX
import { useGetRolesLightQuery } from "../../redux/roles/roleAPI";
// AUTHORIZATION
import GETJwtToken from "../../redux/authentication/authentication";
// INTERFACE
import { RoleLightInterface } from "../../interfaces/Roles.interface";

export default function useGetAllRolesLight({ orgId }: { orgId: string }) {
	// ************************************************ */
	// GLOBAL VARIABLES ******************************* */

	// ************************************************ */
	// USE STATE VARIABLES **************************** */
	const [roles, setRoles] = useState<RoleLightInterface[]>([]);
	const [token, setToken] = useState<string | null>(null);
	const [errorObject, setErrorObject] = useState<any>({});
	const [errorMessage, setErrorMessage] = useState<string>("Error");

	// ************************************************ */
	// REDUX SLICE VARIABLES ************************** */

	// ************************************************ */
	// FUNCTIONS ************************************** */

	// ************************************************ */
	// SERVICES AND API CALLS ************************* */
	const { data, isLoading, isError, isFetching, error } = useGetRolesLightQuery(
		{ token, orgId },
		{ skip: !token, refetchOnMountOrArgChange: false }
	);

	// ************************************************ */
	// USE EFFECT ************************************* */
	useEffect(() => {
		GETJwtToken().then(setToken);
	}, []);

	useEffect(() => {
		if (data && data.data) {
			setRoles(data.data);
		}
	}, [data]);

	useEffect(() => {
		if (error) {
			setErrorObject(error);
		}
	}, [error]);

	useEffect(() => {
		if (errorObject && errorObject.data && errorObject.data.message) {
			setErrorMessage(errorObject.data.message);
		}
	}, [errorObject]);

	// ************************************************ */
	// COMPONENT ************************************** */
	return {
		rolesLight: roles,
		isLoadingGetAllRolesLight: isLoading || isFetching,
		errorMessageGetAllRolesLight: errorMessage,
		isErrorGetAllRolesLight: isError,
		totalRowsGetAllRolesLight: data?.total ?? 0,
	};
}
